import type { Id } from '@hq/utils';
import { toQuery, type HttpClient } from '../client';
import type { PageResult } from '../types/result';
import type {
  CreateShortageRequest,
  HandleShortageRequest,
  ShortageHandleResultRow,
  ShortageQuery,
  ShortageRow
} from '../types/shortage';

const BASE = '/wl/shortage';

/** 缺货商品在线申请：科室提交 → 运营处理（加目录/替代/采购/驳回）。 */
export function createShortageApi(http: HttpClient) {
  return {
    list(query: ShortageQuery = {}): Promise<PageResult<ShortageRow>> {
      return http.request<PageResult<ShortageRow>>({ path: BASE, query: toQuery(query) });
    },

    detail(id: Id): Promise<{ shortage: ShortageRow; items: unknown }> {
      return http.request<{ shortage: ShortageRow; items: unknown }>({ path: `${BASE}/${id}` });
    },

    create(body: CreateShortageRequest): Promise<ShortageRow> {
      return http.request<ShortageRow>({ path: BASE, method: 'POST', body });
    },

    handle(id: Id, body: HandleShortageRequest): Promise<ShortageHandleResultRow> {
      return http.request<ShortageHandleResultRow>({
        path: `${BASE}/${id}/handle`,
        method: 'POST',
        body
      });
    }
  };
}

export type ShortageApi = ReturnType<typeof createShortageApi>;
